import React from 'react';
import { LinkButton, type LinkButtonProps } from '@atlaskit/button/new';
import { generatePath, type Route } from '@atlassian/react-resource-router';

type RouteLinkButtonProps = Partial<LinkButtonProps> & {
	to: Route;
	params: {
		[paramName: string]: string | number | boolean | null | undefined;
	};
};

export const RouteLinkButton = ({ to, params, children, ...rest }: RouteLinkButtonProps) => (
	<LinkButton {...rest} key={to.name} href={generatePath(to.path, params)}>
		{children}
	</LinkButton>
);
